import constant from "@/constant";
const OrderCustomer = [
  {
    title: "Hành động",
    key: "operation",
    fixed: "left",
    width: 110,
    isEditByUser: true,
    statusField: "status",
    actions: [
      {
        type: "edit",
        color: "#3f51b5",
        status: [0],
      },
      {
        type: "copy",
        color: "#66bb6a",
        status: [0, 1, 2],
      },
      {
        type: "delete",
        color: "#ee6e73",
        status: [0, 1],
      },
      {
        type: "cancel",
        color: "#ee6e73",
        status: [6],
      },
    ],
    slots: { customRender: "renderAction" },
  },
  {
    width: 150,
    title: "Mã đơn hàng",
    fixed: "left",
    dataIndex: "code",
    isCodeIndex: true,
    isNameIndex: true,
    ellipsis: true,
  },
  {
    width: 180,
    title: "Trạng thái",
    fixed: "left",
    dataIndex: "status",
    dataType: "list",
    dataSource: constant.orderCustomerStatus,
    ellipsis: true,
    disableSearch: true,
  },
  {
    width: 150,
    title: "Ngày đặt hàng",
    dataIndex: "order_date",
    dataType: "date",
    ellipsis: true,
    disableSearch: true,
  },

  {
    width: 200,
    title: "Điểm nhận hàng",
    dataIndex: "name_of_location_destination_id",
    originalIndex: "ld.title",
    ellipsis: true,
    dataType: "text",
  },
  {
    width: 180,
    title: "Ngày nhận hàng",
    dataIndex: "ETD_date_time",
    dataType: "datetime",
    originalIndex: "ETD_date",
    ellipsis: true,
  },
  {
    width: 200,
    title: "Điểm trả hàng",
    dataIndex: "name_of_location_arrival_id",
    originalIndex: "la.title",
    ellipsis: true,
    dataType: "text",
  },
  {
    width: 180,
    title: "Ngày trả hàng",
    dataIndex: "ETA_date_time",
    dataType: "datetime",
    originalIndex: "ETA_date",
    ellipsis: true,
  },
  {
    width: 200,
    title: "Tổng quãng đường (km)",
    dataIndex: "distance",
    dataType: "number",
    isBold: true,
  },
  {
    width: 200,
    title: "Tổng khối lượng (kg)",
    dataIndex: "weight",
    dataType: "number",
    isBold: true,
  },
  {
    width: 200,
    title: "Tổng dung tích (m3)",
    dataIndex: "volume",
    dataType: "number",
    isBold: true,
  },
  {
    width: 200,
    title: "Số khung",
    dataIndex: "vin_nos",
    dataType: "text",
  },
  {
    width: 200,
    title: "Số model",
    dataIndex: "model_nos",
    dataType: "text",
  }
];

const Location = [
  {
    width: 150,
    title: "Mã địa điểm",
    fixed: "left",
    dataIndex: "code",
    ellipsis: true,
  },
  {
    width: 200,
    title: "Tên",
    dataIndex: "title",
    isNameIndex: true,
    ellipsis: true,
    dataType: "text",
  },
  {
    width: 200,
    ellipsis: true,
    title: "Địa chỉ",
    dataIndex: "address",
    ellipsis: true,
    dataType: "text",
  },
  {
    width: 150,
    ellipsis: true,
    title: "Tỉnh/Thành phố",
    dataIndex: "name_of_province_id",
    originalIndex: "province.title",
  },
  {
    width: 150,
    ellipsis: true,
    title: "Quận/Huyện",
    dataIndex: "name_of_district_id",
    originalIndex: "district.title",
  },
  {
    width: 150,
    title: "Xã/Phường",
    dataIndex: "name_of_ward_id",
    originalIndex: "ward.title",
  },
  {
    width: 200,
    ellipsis: true,
    title: "Kinh độ",
    dataIndex: "latitude",
  },
  {
    width: 200,
    ellipsis: true,
    title: "Vĩ độ",
    dataIndex: "longitude",
  },
];


export default {
  OrderCustomer,
  Location,
};
